import React from 'react';
import { Text } from 'ink';
import { theme } from './theme.js';

export type Status = 'success' | 'error' | 'pending' | 'loading' | 'warning';

interface StatusIconProps {
    status: Status;
    text?: string;
}

/**
 * Status icon component with optional text
 */
export const StatusIcon: React.FC<StatusIconProps> = ({ status, text }) => {
    const iconMap: Record<Status, string> = {
        success: theme.icons.success,
        error: theme.icons.error,
        pending: theme.icons.pending,
        loading: theme.icons.loading,
        warning: theme.icons.warning,
    };

    const colorMap: Record<Status, string> = {
        success: 'green',
        error: 'red',
        pending: 'gray',
        loading: 'yellow',
        warning: 'yellow',
    };

    const icon = iconMap[status];
    const color = colorMap[status];

    return (
        <Text color={color}>
            {icon} {text}
        </Text>
    );
};
